module.exports = __webpack_public_path__ + "static/media/movies.1b4ef14c.png";